import React, {useRef, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import NavComponent from "./NavComponent";
import FooterComponent from "./FooterComponent";

function LoginComponent() {
    const navigate = useNavigate();
    const [formDataLogin, setFormDataLogin] = useState({
        email:'',
        password:''
    });

    const [showPassword, setShowPassword] = useState(false);

    const reenviamear_registro = () => {
        window.scrollTo(0, 0);
        navigate('/registro');
    };

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFormDataLogin(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        console.log(formDataLogin);
        try {
            {/* https://apis.grupobrame.com/heroes/api/login*/}
            const response = await fetch("https://apis.grupobrame.com/heroes/api/login", {

                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    correo: formDataLogin.email,
                    contraseña: formDataLogin.password,
                })
            });

            const result = await response.json();
            if (result.success) {
                /*alert("Login exitoso");*/
                localStorage.removeItem('usuario_data'); // Borra el usuario guardado
                localStorage.setItem('usuario_data', JSON.stringify(result));
                window.scrollTo(0, 0);
                navigate('/mi_avance');
                window.location.reload();

            } else {
                alert("Error: " + result.message);
            }
        } catch (err) {
            alert("Error al iniciar sesión: " + err);
        }
    };


    return (
    <div>
        <NavComponent />
            <div className="flex min-h-full flex-1 flex-col justify-center py-4 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <h2 className="mt-6 text-center text-4xl/9 font-bold tracking-tight text-gray-900">
                        Súper Unidos: HéroesBrame
                    </h2>
                </div>


                <div className="my-4 sm:mx-auto sm:w-full sm:max-w-4xl mx-4">
                    <img src={require('../img/web.png')} alt="" className="hidden sm:block rounded-xl "/>
                    <img src={require('../img/movil.png')} alt="" className="block sm:hidden rounded-xl"/>
                </div>
                <div className="my-4 sm:mx-auto sm:w-full sm:max-w-[480px] text-left">
                    <div className="bg-white px-6 sm:py-12 shadow-sm sm:rounded-lg sm:px-12">
                        <form onSubmit={handleSubmit} method="POST" className="space-y-6">
                            <div>
                                <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                    Correo/Usuario
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        required
                                        value={formDataLogin.email}
                                        onChange={handleChange}
                                        autoComplete="email"
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-400 sm:text-sm/6"
                                    />
                                </div>
                            </div>



                            <div className="sm:col-span-3 col-span-6">
                                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                                    Contraseña
                                </label>
                                <div className="mt-2 relative">
                                    <input
                                        id="password"
                                        name="password"
                                        type={showPassword ? 'text' : 'password'}
                                        autoComplete="password"
                                        value={formDataLogin.password}
                                        onChange={handleChange}
                                        required
                                        className="block w-full rounded-md bg-white px-3 py-1.5 pr-10 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
                                    >
                                        {showPassword ? (
                                            // Ojo abierto
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none"
                                                 viewBox="0 0 24 24" stroke="orange">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                      d="M2.458 12C3.732 7.943 7.522 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.478 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                        ) : (
                                            // Ojo tachado
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none"
                                                 viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a9.956 9.956 0 012.341-3.948m3.507-2.507A9.956 9.956 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.967 9.967 0 01-4.205 5.568M15 12a3 3 0 00-4.243-2.828M3 3l18 18" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>


                            <div>
                                <button
                                    type="submit"
                                    className="flex w-full justify-center rounded-md bg-orange-400 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-orange-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                                >
                                    Iniciar Sesión
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="mt-10">
                        <div className="relative">
                            <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-gray-200" />
                            </div>
                            <div className="relative flex justify-center text-sm/6 font-medium">
                                <span className="bg-white px-6 text-gray-900">O registrarse</span>
                            </div>
                    </div>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px] text-left">
                    <div className="bg-white px-6 py-12 shadow-sm sm:rounded-lg sm:px-12">
                        <div>
                            <button
                                onClick={reenviamear_registro}
                                className="flex w-full justify-center rounded-md bg-orange-400 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-orange-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                            >
                                Registrarme
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterComponent />
    </div>
    );
}

export default LoginComponent;

/**
 * scroll en 0 en cada recarga de pagina
 * */